import React, { useState, useEffect } from 'react'
import { Col, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import BookingManagementScholarsSearch from '../../durableArticlesWidget/bookingManagementScholarsWidget/BookingManagementScholarsSearch'
import BookingManagementScholarsTable from '../bookingManagementScholarsWidget/BookingManagementScholarsTable'
import BookingManagementScholarsForm from '../bookingManagementScholarsWidget/BookingManagementScholarsForm'

export default function BookingManagementScholarsWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [voucherSchema, setVoucherSchema] = useState()
  const [dataTable, setDataTable] = useState(props.schema.formTable)
  const [formDisplayLists, setFormDisplayLists] = useState()

  console.log('/*********/ ', formSchema?.form?.formTable)

  return (
    <>
      {formSchema?.form?.search && (
        <Panel shaded collapsible defaultExpanded header={'ค้นหารายการจอง'} bordered>
          <BookingManagementScholarsSearch
            schema={formSchema?.form?.search}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </Panel>
      )}

      {formSchema?.form?.formTable && (
        <Panel shaded collapsible defaultExpanded header={' '} style={{ marginTop: 10 }}>
          <BookingManagementScholarsTable schema={formSchema?.form?.formTable} />
        </Panel>
      )}

      <Panel shaded collapsible defaultExpanded header={' '} style={{ marginTop: 10 }}>
        <BookingManagementScholarsForm
          schema={formSchema?.form?.search}
          Controller={Controller}
          control={control}
        />
      </Panel>
    </>
  )
}
